import React from 'react';
import {IonButton, IonIcon} from '@ionic/react';
import {warningOutline} from 'ionicons/icons';

interface ErrorMessageProps {
    message: string;
    isVisible: boolean;
    actionLabel?: string;
    actionLink?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, isVisible, actionLabel, actionLink }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '20px', padding: '10px', backgroundColor: 'rgba(255,137,4,0.1)', border: '1px solid orange', borderRadius: '5px', flexWrap: 'wrap' }}>
            <IonIcon icon={warningOutline} style={{ flexShrink: 0, width: '30px', height: '30px' }} />
            <span style={{ flex: 1, minWidth: '220px' }}>{message}</span>
            {actionLabel && actionLink && (
                <IonButton routerLink={actionLink} fill="outline" color="warning">
                    {actionLabel}
                </IonButton>
            )}
        </div>
    );
};

export default ErrorMessage;
